import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  displayProfileModal,
  setProfileModalPage,
} from '../../../modules/profile/actions/creators'

import AddCardPage from '../components/AddCardPage/AddCardPage'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState

  const { accessToken } = auth

  const { primaryInfo, showProfileModal, profileModalPage } = profile

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      displayProfileModal,
      setProfileModalPage,
    },
    dispatch,
  )

const ConnectedAddCardPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddCardPage)

export default ConnectedAddCardPage
